var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-information_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".ico-information_svg__st1{fill:#01182c}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-information_svg__ico-information",
    transform: "translate(-250.617 -6.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-information_svg__Rond"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16S0 24.8 0 16 7.2 0 16 0z",
    fill: "none",
    transform: "translate(250.617 6.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ico-information_svg__st1",
    d: "M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zm0-31C7.7 1 1 7.7 1 16s6.7 15 15 15 15-6.7 15-15S24.3 1 16 1z",
    transform: "translate(250.617 6.709)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ico-information_svg__st1",
    d: "M265 16.1c0-1 .7-1.6 1.7-1.6s1.7.6 1.7 1.6-.7 1.6-1.7 1.6-1.7-.6-1.7-1.6zm.2 3.4h2.9v11.2h-2.9V19.5z"
  }))));
}

export default SvgIcoInformation;